<template>
  <report-page
    v-for="(page, index) in pages"
    :key="index"
    :index="index"
    :page="page"
    :preview="true"
  >
    <gridstack-container
      :ref="'p'+page.id+'-gridstack'"
      :page="page"
      :preview="true"
      :widget-data-url="urls.widgetData"
    />
  </report-page>
</template>
<script>
import {mapActions, mapState} from 'vuex'
import ReportPage from '../builder/includes/ReportPage.vue';
import GridstackContainer from '../builder/includes/GridstackContainer.vue';

export default {
  components: {
    ReportPage,
    GridstackContainer
  },
  props: {
    uuid: {
      type: String,
      required: true
    },
    template: {
      type: Boolean,
      required: true
    },
    dataUrls: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      pagesizes: {
        A4: {
          portrait: {
            height: '297mm',
            width: '210mm'
          },
          landscape: {
            height: '209.5mm',
            width: '297mm'
          },
        },
        Letter: {
          portrait: {
            height: '279mm',
            width: '216mm'
          },
          landscape: {
            height: '216mm',
            width: '279mm'
          },
        },
      }
    }
  },
  computed: {
    ...mapState('report', ['report']),
    ...mapState('pages', ['pages']),
    // Signed URLs minted server side - the page cannot sign its own requests.
    urls() {
      return JSON.parse(this.dataUrls);
    }
  },
  async mounted() {
    // The range override is already baked into the signed report URL, so it no
    // longer needs reading back off window.location.
    await this.fetchReportByUUID({url: this.urls.report});
    await this.getPreviewReportPages({url: this.urls.pages});
    this.setPageSize(this.report.paper_size + ' ' + this.report.orientation);
  },
  methods: {
    ...mapActions({
      fetchReportByUUID: 'report/fetchReportByUUID',
      getPreviewReportPages: 'pages/getPreviewReportPages',
    }),
    setPageSize(cssPageSize) {
      const style = document.createElement('style');
      style.innerHTML = `@page {size: ${cssPageSize}} @media print { body { width: ${this.pagesizes[this.report.paper_size][this.report.orientation].width};} }`;
      document.head.appendChild(style);
    }
  }
}
</script>

